import { render } from "./DashboardLojista.vue?vue&type=template&id=78d6b81a"
import script from "./DashboardLojista.vue?vue&type=script&lang=js"
export * from "./DashboardLojista.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Rafael\\projetos\\laravel\\enjoy_inertia\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__